import { Box, Stack } from '@mui/material';
import { FeatureSwitchGate, Features } from '@billda/features-ui';
import { PermissionGate, Permissions } from '@billda/permissions-ui';
import { DashboardHeader } from '../components/DashboardHeader';
import { DashboardSiteBurndown } from '../components/DashboardSiteBurndown';
import { MetricsGrid } from '../components/organisms/MetricsGrid';
import { OpenPotsWidget } from '../components/OpenPotsWidget';
import { PotStatusOverview } from '../components/PotStatusOverview';
import { UnapprovedAllocationsWidget } from '../components/UnapprovedAllocationsWidget';
import { WeeklyAllocationTrend } from '../components/WeeklyAllocationTrend';

export default function DashboardPage() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto', p: 3 }}>
        <Stack spacing={3} sx={{ maxWidth: 'xl' }}>
          <DashboardHeader />
          <MetricsGrid />
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              gap: 3,
              alignItems: 'stretch',
            }}
          >
            <PotStatusOverview />
            <WeeklyAllocationTrend />
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              gap: 3,
              alignItems: 'stretch',
            }}
          >
            <FeatureSwitchGate
              feature={Features.Dashboard.IsUnapprovedAllocationsEnabled}
            >
              <PermissionGate permission={Permissions.Labour.Approve}>
                <UnapprovedAllocationsWidget />
              </PermissionGate>
            </FeatureSwitchGate>
            <FeatureSwitchGate feature={Features.Dashboard.IsOpenPotsEnabled}>
              <PermissionGate permission={Permissions.Pots.All.Read}>
                <OpenPotsWidget />
              </PermissionGate>
            </FeatureSwitchGate>
          </Box>
          <FeatureSwitchGate
            feature={Features.Dashboard.IsSiteBurndownChartEnabled}
          >
            <PermissionGate permission={Permissions.Sites.Financial.Read}>
              <DashboardSiteBurndown />
            </PermissionGate>
          </FeatureSwitchGate>
        </Stack>
      </Box>
    </Box>
  );
}
